import { debounce as _debounce } from 'lodash';

import { listHealthcareSites } from './index';

export default _debounce(listHealthcareSites, 350);
